<template>
    <img v-if="url" v-show="href" class="vrm-qrcode" :src="url" />
</template>
<style scoped lang="less">
.vrm-qrcode {
    display: block;
    margin: 0 auto;

    width: 100%;
    height: auto;

    max-width: 300px;
    max-height: 300px;

    image-rendering: pixelated;
}
</style>
<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import qrcode from 'qrcode';

@Component
export default class VrmMfaQrCode extends Vue {
    @Prop({ type: String, default: null })
    href;

    url = null;
    pendingRender = null;

    mounted() {
        this.renderToCanvas();
    }

    @Watch('href')
    async renderToCanvas() {
        if (!this.$el) return;
        if (this.pendingRender) {
            await this.pendingRender;
        }
        this.pendingRender = this.generateUri(this.href);
        this.url = null;
        try {
            this.url = await this.pendingRender;
        } finally {
            this.pendingRender = null;
        }
    }

    async generateUri(code) {
        if (code) {
            return await qrcode.toDataURL(code);
        } else {
            return null;
        }
    }
}
</script>
